import type React from 'react';
import { Component } from 'react';
import { ActivityFilterType } from 'redux/modules/activities.types';
import type { Activity } from 'types/activity';

interface State {
  filteredBy: ActivityFilterType;
}
interface Props {
  activities: Array<Activity>;
  render: (props: {
    filteredActivities: Array<Activity>;
    filteredBy: ActivityFilterType;
    hasAnomalies: boolean;
    handleFilterActivities: (selection: ActivityFilterType) => void;
  }) => React.ReactNode;
}

export default class WithFilteredActivities extends Component<Props, State> {
  state: State = {
    filteredBy: ActivityFilterType.All,
  };

  handleFilterActivities = (selection: ActivityFilterType) => {
    this.setState({ filteredBy: selection });
  };

  filteredActivities = (): Array<Activity> => {
    if (this.state.filteredBy === ActivityFilterType.Anomalies) {
      return this.props.activities.filter(activity => activity.isAnomaly);
    }

    if (this.state.filteredBy === ActivityFilterType.Regular) {
      return this.props.activities.filter(activity => !activity.isAnomaly);
    }

    return this.props.activities;
  };

  render(): React.ReactNode {
    const filteredActivities = this.filteredActivities();
    const hasAnomalies = this.props.activities.some(activity => activity.isAnomaly);

    return this.props.render({
      filteredActivities,
      filteredBy: this.state.filteredBy,
      hasAnomalies,
      handleFilterActivities: this.handleFilterActivities,
    });
  }
}
